import { useEffect, useState } from "react";
import { Flight } from "../models/flight";
import { Airport } from "../models/airport";
import createGame from "../services/game";
import fetchAirports from "../services/fetch_airports";
import fetchFlightPath from "../services/fetch_flightpath";

const loadGame = (
  difficulty: "easy" | "medium" | "hard",
  region: "usa" | "eur" | "world"
) => {
  const [flights, setFlights] = useState<Flight[]>([]);
  const [gameId, setGameId] = useState<string | null>(null);
  const [airports, setAirports] = useState<Airport[]>([]);
  const [numberOfGamesPlayedByUser, setNumberOfGamesPlayedByUser] = useState(0);
  const [gameError, setGameError] = useState<string | null>(null);

  useEffect(() => {
    const abortController = new AbortController();

    const createGameBlock = async (
      difficulty: "easy" | "medium" | "hard",
      region: "usa" | "eur" | "world"
    ) => {
      try {
        const gameData = await createGame(
          difficulty,
          region,
          abortController.signal
        );
        setFlights(gameData.flights);
        setGameId(gameData.id);
        setNumberOfGamesPlayedByUser(gameData.numberOfGamesPlayedByUser);
        setGameError(null);
      } catch (error) {
        console.error(error);
        if (
          error instanceof Error &&
          error.name !== "AbortError" &&
          error.name !== "CanceledError"
        ) {
          setGameError("Failed to create game");
        }
      }
    };
    createGameBlock(difficulty, region);

    return () => {
      abortController.abort();
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchAirportsBlock = async (
      difficulty: "easy" | "medium" | "hard",
      region: "usa" | "eur" | "world"
    ) => {
      try {
        const airports = await fetchAirports(
          difficulty,
          region,
          abortController.signal
        );
        setAirports(airports);
      } catch (error) {
        console.error(error);
      }
    };

    fetchAirportsBlock(difficulty, region);

    return () => {
      abortController.abort();
    };
  }, []);

  return {
    flights,
    airports,
    gameId,
    numberOfGamesPlayedByUser,
    gameError,
  };
};

const loadFlightPath = async (flight: Flight) => {
  return fetchFlightPath(flight);
};

export default loadGame;
export { loadFlightPath };
